import { useEffect, useState } from "react"

export const MOBILE_LAYOUT_MAX_WIDTH = 900

function getIsMobileLayout(maxWidth: number) {
  if (typeof window === "undefined") return false
  return window.matchMedia(`(max-width: ${maxWidth}px)`).matches
}

export function useMobileLayout(maxWidth = MOBILE_LAYOUT_MAX_WIDTH) {
  const [isMobileLayout, setIsMobileLayout] = useState(() =>
    getIsMobileLayout(maxWidth),
  )

  useEffect(() => {
    if (typeof window === "undefined") return
    const query = window.matchMedia(`(max-width: ${maxWidth}px)`)
    const update = (event?: MediaQueryListEvent) => {
      setIsMobileLayout(event?.matches ?? query.matches)
    }

    update()
    if (typeof query.addEventListener === "function") {
      query.addEventListener("change", update)
      return () => query.removeEventListener("change", update)
    }

    query.addListener(update)
    return () => query.removeListener(update)
  }, [maxWidth])

  return isMobileLayout
}
